import { IconButton } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";

function SendIconButton({ onClick }) {
  return (
    <IconButton
      aria-label="送出"
      icon={<ArrowForwardIcon />}      // 這裡放 Chakra 的圖示
      colorScheme="teal"               // 主色
      borderRadius="full"              // 圓形按鈕
      size="md"                        // sm | md | lg
      onClick={onClick}
    />
  );
}

export default SendIconButton;
